import React from 'react';
import { useNavigate } from 'react-router-dom';

import '../styles/Button.css';

const Button = ({ children , onClick, to, type = 'normal', icon, loadingPercent=0 }) => {
  var buttonClass = 'button-normal';

  if(type === 'priority') buttonClass = "button-priority";
  if(type === 'inactive') buttonClass = "button-inactive";
  if(type === 'loading')  buttonClass = "button-loading";
  if(type === 'loadingNormal')  buttonClass = "button-loading-normal";
  if(loadingPercent) buttonClass = "button-loading-back";
  
  if(icon) {
      buttonClass += " button-icon";
  }
  var buttonIcon = children ? "button-panel-icon-text" : 'button-panel-icon';
  
  const navigate = useNavigate();

  const handleClick = () => {
    if (onClick) onClick();
    if (to) navigate(to);
  };

  const isLoading = (type === "loading" || type === "loadingNormal");

  return (
    <button className={buttonClass} onClick={handleClick}>
      { isLoading &&
          <>
            {loadingPercent!==0 && (<div className="button-loading-progress" style={{ width: loadingPercent+"%" }} ></div>)}
            <div className="button-loading-dots">
              <span></span>
              <span></span>
              <span></span>
              <span></span>
            </div>
          </>
      }
      {!isLoading && icon && <div className={buttonIcon}><img src={icon} alt="Icon" height={"40%"} /><div className="button-panel-text">{children}</div></div>}
      {!isLoading && !icon && children}
    </button>
  ); 
};

export default Button;